import Model, { attr, belongsTo } from '@ember-data/model';

export default class DownloadRequestModel extends Model {
  @attr('string') projectFileVersionId;
  @attr('string') url;
}
